import React, {Fragment} from 'react'
import {connect} from 'react-redux'
import {ApplicationState, ConnectedReduxProps} from '@reducers/index'
import {Person} from '@models/person-role'
import PersonRoleForm from "@components/person-roles/Form";
import {createRequest, updateRequest} from '@actions/person-role';
import personApi from '@api/person-role'
import {injectIntl} from 'react-intl';


interface PropsFromState {
  loading: boolean
  data: Person[]
  errors?: string,
  count: number
}

interface PropsFromDispatch {
  createRequest: typeof createRequest
  updateRequest: typeof updateRequest
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps


class PersonRoleFormPage extends React.Component<AllProps> {
  
  state = {
    personRole: null,
    role_id: this.props.match.params.id,
    is_fetched: false
  };
  
  componentDidMount() {
    if (this.state.role_id) {
      this.fetchItem();
    }
  }
  
  fetchItem = () => {
    personApi.getItem({
        params: {
          id: this.state.role_id,
        }
      })
      .then(({data}) => {
        this.setState({
          personRole: data
        })
      })
      .catch((error) => console.log(error))
  };
  
  getContent = () => {
    if (this.state.role_id && !this.state.personRole) {
      return null
    }
    
    return (
      <PersonRoleForm
        personRole={this.state.personRole}
        intl={this.props.intl}
        listUrl={"/people/roles"}
        history={this.props.history}
        updateRequest={this.props.updateRequest}
        createRequest={this.props.createRequest}/>
    )
  };
  
  render() {
    return (
      <Fragment>
        {this.getContent()}
      </Fragment>
    )
  }
}


const mapStateToProps = ({personRoles}: ApplicationState) => ({
  loading: personRoles.loading,
  errors: personRoles.errors
});

const mapDispatchToProps = {
  createRequest,
  updateRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(
  injectIntl(PersonRoleFormPage));



